// extracted by mini-css-extract-plugin
module.exports = {"star":"StarRating_star__2qEOP","review-count":"StarRating_review-count__HwwL8","total-reviews":"StarRating_total-reviews__v_si3"};